import CircleParkingSvg from '@assets/images/svg/circle-parking.svg';
import React from 'react';
import { View } from 'react-native';

export interface CircleParkingIconProps {
    size?: number;
    color?: string;
}

export function CircleParkingIcon({ size = 24, color = '#4D4D4D' }: CircleParkingIconProps) {
    return (
        <View style={{ width: size, height: size, justifyContent: 'center', alignItems: 'center' }}>
            <CircleParkingSvg width={size} height={size} color={color} />
        </View>
    );
}

export default CircleParkingIcon;
